import { Outlet } from 'react-router-dom';
import { Auth0ProviderWithNavigate } from '../../auth0-provider';
import { useEpcsActivationWatcher } from '@features/eprescriptions';
import { Toolbar, DEFAULT_TOOLBAR_ACTIONS } from '@features/toolbar';
import { useFeatureFlags } from '@features/user';
import { useSystemNotificationModals } from '@features/system-notifications';
import { useGlobalKeyboardShortcuts } from '../../hooks/useGlobalKeyboardShortcuts';

/**
 * Layout component that handles authentication and wraps
 * authenticated routes
 */
export const AuthenticatedLayout = () => {
  const featureFlags = useFeatureFlags();

  // Trigger system notification modals when they become active
  useSystemNotificationModals();

  // Watch for EPCS activation and show toast on status change
  useEpcsActivationWatcher();

  // ⌘K command palette + future app-wide shortcuts
  useGlobalKeyboardShortcuts();

  // Only render toolbar if any of these feature flags are enabled
  const shouldShowToolbar =
    featureFlags.lab_orders ||
    featureFlags.stripe_connect ||
    featureFlags.forms ||
    featureFlags.document_generation;

  return (
    <Auth0ProviderWithNavigate>
      <Outlet />
      {shouldShowToolbar && <Toolbar actions={DEFAULT_TOOLBAR_ACTIONS} />}
    </Auth0ProviderWithNavigate>
  );
};
